/*
  (C) Belvano · HeyLight Info-Icon → Popup.

  Inline überall nur die kurze Rate-Zeile „oder N × CHF" + ein kleines ⓘ.
  Klick aufs ⓘ öffnet EIN gemeinsames Modal, in dem HeyLights OFFIZIELLES
  Widget (mit deren Logo/Text) on-demand gerendert wird — das SDK ist beim
  Klick längst geladen, daher zuverlässig (anders als beim Inline-Widget in
  dynamisch getauschten Flächen).

  Trigger: jedes Element mit [data-heylight-info] und data-hl-amount (Rappen).
*/
(function () {
  if (window.__blvHlInfo) return;
  window.__blvHlInfo = true;

  var API_KEY = '12dda028bac7b645ee33c9880c4393059c01d0d3';
  var SDK = 'https://upstream.heidipay.com/sdk/heidi-upstream-lib.js';
  var MIN_RATE = 20000, MIN = 60000, MAX = 2000000, TERMS = [3, 4, 6, 10, 12];

  // SDK früh laden, damit es beim ersten Klick bereitsteht.
  if (!document.querySelector('script[data-heylight-sdk]')) {
    var s = document.createElement('script');
    s.src = SDK; s.async = true; s.setAttribute('data-heylight-sdk', '');
    document.head.appendChild(s);
  }

  function term(total) {
    if (total < MIN || total > MAX) return null;
    var ceiling = total / MIN_RATE, t = null;
    TERMS.forEach(function (x) { if (x <= ceiling) t = x; });
    return t;
  }

  function lang() {
    return (document.documentElement.lang || 'de').slice(0, 2);
  }

  // --- Modal einmal bauen ---
  var modal = document.createElement('div');
  modal.className = 'blv-hlm';
  modal.hidden = true;
  modal.innerHTML =
    '<div class="blv-hlm__backdrop" data-hlm-close></div>' +
    '<div class="blv-hlm__panel" role="dialog" aria-modal="true" aria-label="Ratenzahlung mit HeyLight">' +
    '<button type="button" class="blv-hlm__close" data-hlm-close aria-label="Schliessen">' +
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
    '</button>' +
    '<p class="blv-hlm__title">In Raten zahlen — 0% Zinsen</p>' +
    '<div class="blv-hlm__widget" data-hlm-widget></div>' +
    '<p class="blv-hlm__note">Bezahlung in bequemen Monatsraten über unseren Partner HeyLight. Auswahl und Bonitätsprüfung im Checkout.</p>' +
    '</div>';
  document.body.appendChild(modal);
  var widgetSlot = modal.querySelector('[data-hlm-widget]');

  function open(amount) {
    var t = term(amount);
    if (t) {
      widgetSlot.innerHTML =
        '<div class="heidipay-container-2" data-heidipay="true"' +
        ' data-heidipay-widgetId="hl-info-modal"' +
        ' data-heidipay-minorAmount="' + amount + '"' +
        ' data-heidipay-term="' + t + '"' +
        ' data-heidipay-currencySymbol="CHF"' +
        ' data-heidipay-lang="' + lang() + '"' +
        ' data-heidipay-type="PRODUCT_DESCRIPTION_HEYLIGHT_BNPL_CH"' +
        ' data-heidipay-apiKey="' + API_KEY + '"' +
        ' data-heidipay-cadence="MONTHLY"' +
        ' data-heidipay-thousandsSeparator="."' +
        ' data-heidipay-decimalSeparator=","' +
        ' data-heidipay-symbolOnLeft="false"' +
        ' data-heidipay-spaceBetweenAmountAndSymbol="true"' +
        ' data-heylight-logo-variant="black"' +
        ' data-heidipay-decimalDigits="2"></div>';
    } else {
      widgetSlot.innerHTML = '';
    }
    modal.hidden = false;
    document.documentElement.classList.add('blv-hlm-open');
    // SDK hydrieren (bis zu ~6s pollen, falls es noch lädt).
    var n = 0;
    (function hydrate() {
      if (window.initCoreHeidiCode) { try { window.initCoreHeidiCode(); } catch (e) {} return; }
      if (n++ < 40) setTimeout(hydrate, 150);
    })();
  }

  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('blv-hlm-open');
  }

  modal.querySelectorAll('[data-hlm-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  // Delegierter Klick-Handler für alle ⓘ (überlebt Re-Renders).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-heylight-info]');
    if (!trigger) return;
    e.preventDefault();
    var amount = parseInt(trigger.getAttribute('data-hl-amount'), 10) || 0;
    open(amount);
  });
})();
